module.exports = __webpack_public_path__ + "img/yingdao.0c925fb4.png";